import { observer } from 'mobx-react-lite'
import { ArchiveJobDialog } from '@/features/jobs/ArchiveJobDialog'
import type { ArchiveJobDialogViewModel } from '@/features/jobs/ArchiveJobDialog/ArchiveJobDialogViewModel'

interface ArchiveJobDialogContainerProps {
  vm: ArchiveJobDialogViewModel
}

/**
 * Container component for the archive job dialog.
 * Connects the ArchiveJobDialogViewModel to the presentation component,
 * extracting observable state and binding event handlers.
 */
export const ArchiveJobDialogContainer = observer(
  function ArchiveJobDialogContainer({ vm }: ArchiveJobDialogContainerProps) {
    const jobName = vm.displayName
    const isPending = vm.archive.pending

    return (
      <ArchiveJobDialog
        jobName={jobName}
        isOpen={vm.modal.showing}
        isPending={isPending}
        onArchive={() => vm.archive()}
        onClose={() => vm.cancel()}
      />
    )
  },
)
